import { withInstall } from '../../../../utils/with-install'
import Canvas from './Canvas.vue'

export const ElAmapLayerCanvas = withInstall(Canvas)
export default ElAmapLayerCanvas
